import { render } from "./CalendarWeekComponent.vue?vue&type=template&id=5afde9c7"
import script from "./CalendarWeekComponent.vue?vue&type=script&lang=js"
export * from "./CalendarWeekComponent.vue?vue&type=script&lang=js"

import "./CalendarWeekComponent.vue?vue&type=style&index=0&id=5afde9c7&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__